const categoryCooldownLabels = Object.freeze({
  minutes: 'Engagement_Category_Minutes',
  hours: 'Engagement_Category_Hours',
  days: 'Engagement_Category_Days',
  weeks: 'Engagement_Category_Weeks',
  months: 'Engagement_Category_Months'
})

const nationalExclusionTypeLabels = Object.freeze({
  0: 'Engagement_Category_National_Exclusion_MarketingTechsson',
  1: 'Engagement_Category_National_Exclusion_ServiceTechsson',
  2: 'Engagement_Category_National_Exclusion_GeneralTechsson',
  10: 'Engagement_Category_National_Exclusion_MarketingOasis',
  11: 'Engagement_Category_National_Exclusion_MarketingBonusOasis'
})
const nationalExclusionTypes = Object.freeze({
  marketing: 0,
  service: 1,
  general: 2,
  marketing_oasis: 10,
  marketing_bonus_oasis: 11
})

export {
  categoryCooldownLabels,
  nationalExclusionTypeLabels,
  nationalExclusionTypes
}



// WEBPACK FOOTER //
// ./src/common/enum/CategoryEnums.js